/* Dependencies */
import styled from 'styled-components';

export const PermissionItem = styled.div.attrs(() => ({
  className: 'AddDirectorDefaultPermissionItem',
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 16px;
`;

export const PermissionTitle = styled.h4.attrs(() => ({
  className: 'AddDirectorDefaultPermissionTitle',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
  margin-bottom: 4px;
`;

export const PermissionText = styled.div.attrs(() => ({
  className: 'AddDirectorDefaultPermissionText',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0;
  margin-right: 10px;
`;